export enum Page {
  PERSONALIZATION = 'personalization',
  WRAP = 'wraps',
  MORE_PRODUCTS = 'moreProducts',
}
